(function($) {
    $(document).ready(function() {
        $('.thumb-list__lightbox').magnificPopup({
            type: 'image',
            closeOnContentClick: true,
            image: {
                verticalFit: true
            },
            titleSrc: function() {
                return item.el.attr('title') ? item.el.attr('title') : item.el.attr('alt');
            }
        });
    });
})(jQuery);
